import { render, staticRenderFns } from "./UsuarioRegisterV.vue?vue&type=template&id=75781345"
import script from "./UsuarioRegisterV.vue?vue&type=script&lang=js"
export * from "./UsuarioRegisterV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports